import api from "./api";

export const createComment = async (postId, commentData) => {
    const token  = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("尚未登入");
    }
    const response = await api.post(`posts/${postId}/comments/`, commentData, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

export const getComments = async (postId) => {
    const response = await api.get(`posts/${postId}/comments/`);
    return Array.isArray(response.data) ? response.data : [];
};
